export default __webpack_public_path__ + "static/media/vantagem.e113f159.png";